import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, accent, subtitle }) {
  return (
    <section className="pt-24 pb-10 lg:pt-32 lg:pb-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        {eyebrow && (
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center gap-3 mb-5"
          >
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37]">
              {eyebrow}
            </span>
          </motion.div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.05 }}
          className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight leading-[1.02]"
        >
          {title}
          {accent && (
            <>
              <br />
              <span className="text-[#D4AF37]">{accent}</span>
            </>
          )}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="mt-6 max-w-xl text-base sm:text-[17px] text-slate-300 leading-[1.7]"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
